(function(){
  'use strict';

  function normalize(value){
    var text=String(value||'').toLowerCase().trim();
    if(text.normalize)text=text.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    return text.replace(/\s+/g,' ');
  }

  function setShareStatus(root,message){
    var status=root.querySelector('[data-nnj-share-status]');
    if(!status)return;
    status.textContent='';
    window.setTimeout(function(){status.textContent=message;},20);
  }

  function copyText(value){
    if(navigator.clipboard&&navigator.clipboard.writeText)return navigator.clipboard.writeText(value);
    return new Promise(function(resolve,reject){
      var field=document.createElement('textarea');
      field.value=value;
      field.setAttribute('readonly','');
      field.style.position='fixed';
      field.style.opacity='0';
      document.body.appendChild(field);
      field.select();
      try{
        if(document.execCommand('copy'))resolve();
        else reject(new Error('Copy failed'));
      }catch(error){reject(error);}
      document.body.removeChild(field);
    });
  }

  function initBlog(){
    var root=document.querySelector('[data-nnj-blog]');
    if(!root)return;
    var input=root.querySelector('[data-nnj-blog-search-input]');
    var defaultView=root.querySelector('[data-nnj-blog-default]');
    var results=root.querySelector('[data-nnj-blog-results]');
    var status=root.querySelector('[data-nnj-blog-status]');
    var empty=root.querySelector('[data-nnj-blog-empty]');
    var items=Array.prototype.slice.call(root.querySelectorAll('[data-nnj-blog-results] [data-nnj-search-item]'));
    if(!input||!defaultView||!results)return;

    function filterArchive(){
      var query=normalize(input.value);
      if(!query){
        defaultView.hidden=false;
        results.hidden=true;
        items.forEach(function(item){item.hidden=false;});
        if(empty)empty.hidden=true;
        if(status)status.textContent='';
        return;
      }

      var terms=query.split(' ');
      var count=0;
      items.forEach(function(item){
        var text=normalize(item.getAttribute('data-nnj-search-text'));
        var matches=terms.every(function(term){return text.indexOf(term)>-1;});
        item.hidden=!matches;
        if(matches)count+=1;
      });
      defaultView.hidden=true;
      results.hidden=false;
      if(empty)empty.hidden=count!==0;
      if(status)status.textContent=count+' '+(count===1?'note matches':'notes match')+' "'+input.value.trim()+'".';
    }

    input.addEventListener('input',filterArchive);
    input.addEventListener('search',filterArchive);
  }

  function initArticle(){
    var root=document.querySelector('[data-nnj-article]');
    if(!root)return;
    var prose=root.querySelector('[data-nnj-prose]');
    var toc=root.querySelector('[data-nnj-toc]');
    var tocList=root.querySelector('[data-nnj-toc-list]');
    var progress=root.querySelector('[data-nnj-progress]');
    var articleBody=root.querySelector('[data-nnj-article-body]');

    if(toc&&window.matchMedia('(max-width: 980px)').matches)toc.removeAttribute('open');

    if(prose&&toc&&tocList){
      var headings=Array.prototype.slice.call(prose.querySelectorAll('h2,h3'));
      if(headings.length){
        var used={};
        tocList.innerHTML='';
        headings.forEach(function(heading,index){
          var base=normalize(heading.textContent).replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')||'section-'+(index+1);
          var id=base;
          var suffix=2;
          while(used[id]||document.getElementById(id)){id=base+'-'+suffix;suffix+=1;}
          used[id]=true;
          heading.id=id;
          var item=document.createElement('li');
          if(heading.tagName.toLowerCase()==='h3')item.className='is-subsection';
          var link=document.createElement('a');
          link.href='#'+id;
          link.textContent=heading.textContent;
          item.appendChild(link);
          tocList.appendChild(item);
        });

        if('IntersectionObserver' in window){
          var links=Array.prototype.slice.call(tocList.querySelectorAll('a'));
          var observer=new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if(!entry.isIntersecting)return;
              links.forEach(function(link){link.classList.toggle('is-active',link.getAttribute('href')==='#'+entry.target.id);});
            });
          },{rootMargin:'-18% 0px -68% 0px',threshold:0});
          headings.forEach(function(heading){observer.observe(heading);});
        }
      }else{
        toc.hidden=true;
      }
    }

    if(progress&&articleBody){
      var frame=null;
      function updateProgress(){
        frame=null;
        var scrollTop=window.scrollY||document.documentElement.scrollTop;
        var start=articleBody.getBoundingClientRect().top+scrollTop-160;
        var finish=start+articleBody.offsetHeight-window.innerHeight+160;
        var range=Math.max(1,finish-start);
        var percent=Math.max(0,Math.min(1,(scrollTop-start)/range));
        progress.style.width=(percent*100).toFixed(2)+'%';
      }
      function requestProgress(){
        if(frame)return;
        frame=window.requestAnimationFrame(updateProgress);
      }
      updateProgress();
      window.addEventListener('scroll',requestProgress,{passive:true});
      window.addEventListener('resize',requestProgress);
    }

    root.addEventListener('click',function(event){
      var shareButton=event.target.closest('[data-nnj-share]');
      var copyButton=event.target.closest('[data-nnj-copy]');
      if(!shareButton&&!copyButton)return;
      var button=shareButton||copyButton;
      var url=button.getAttribute('data-share-url')||window.location.href;
      if(shareButton&&navigator.share){
        navigator.share({title:shareButton.getAttribute('data-share-title')||document.title,url:url}).then(function(){
          setShareStatus(root,'Share options opened.');
        }).catch(function(error){
          if(error&&error.name==='AbortError')return;
          copyText(url).then(function(){setShareStatus(root,'Link copied.');}).catch(function(){setShareStatus(root,'Copy the page address from your browser.');});
        });
        return;
      }
      copyText(url).then(function(){
        setShareStatus(root,'Link copied.');
        var original=button.textContent;
        button.textContent='Copied';
        window.setTimeout(function(){button.textContent=original;},1400);
      }).catch(function(){setShareStatus(root,'Copy the page address from your browser.');});
    });
  }

  initBlog();
  initArticle();
})();
